import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    align-items: center;
    margin: 20px auto;
`
export const Section = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
    div{
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 20px;
    }
    .img{
        width: 500px;
    }
`
export const Title = styled.h1`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 2em;
  color: #1485c7;
  max-width: 500px;
`
export const Paragraph = styled.p`
  text-align: center;
  max-width: 600px;
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;

`